import { Lotus } from "./Lotus";
import { BRAND, NAV_LINKS } from "../../data";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#151c0f] border-t border-[#b89d62]/20 py-16 px-6">
    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 items-start">
      <div>
        <div className="flex items-center gap-3">
          <Lotus className="w-9 h-7 text-[#b89d62]" />
          <span className="font-serif-display text-3xl tracking-[0.25em] text-[#faf9f6] font-light">
            {BRAND.name}
          </span>
        </div>
        <p className="eyebrow mt-3">{BRAND.subtitle}</p>
        <p className="mt-5 text-sm text-[#c9d3ca] font-light leading-relaxed max-w-xs">
          A sanctuary of Thai healing and quiet luxury in the heart of Barcelona.
        </p>
      </div>

      <div>
        <p className="eyebrow mb-5">Explore</p>
        <ul className="space-y-3">
          {NAV_LINKS.map((l) => (
            <li key={l.id}>
              <button
                onClick={() => scrollTo(l.id)}
                className="text-[#c9d3ca] hover:text-[#b89d62] transition-colors font-light"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="eyebrow mb-5">Visit</p>
        <p className="text-[#c9d3ca] font-light leading-relaxed">{BRAND.address}</p>
        <p className="mt-3 text-[#c9d3ca] font-light">{BRAND.phoneDisplay}</p>
        <p className="text-[#c9d3ca] font-light">{BRAND.email}</p>
      </div>
    </div>

    <div className="max-w-7xl mx-auto mt-14 pt-8 border-t border-[#b89d62]/15 flex flex-col sm:flex-row items-center justify-between gap-3">
      <p className="text-xs text-[#c9d3ca]/70 font-light">
        © {new Date().getFullYear()} Royale Thai Therapeutic Massage. All rights reserved.
      </p>
      <p className="text-xs text-[#c9d3ca]/70 font-light">Barcelona · Thai & Therapeutic</p>
    </div>
  </footer>
);
